import { useNavigate } from "react-router-dom";
import { GoBackButton as StyledGoBackButton } from "./styled";
import IconArrowLeftSvg from "./assets/IconArrowLeftSvg";

export const GoBackButton = ({ to, text = "Вернуться" }) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    // Проверяем, есть ли предыдущая запись в истории текущего сайта
    // idx — это числовой индекс, который увеличивается с каждой новой навигацией в рамках одного сеанса.

    if (to) {
      navigate(to);
      return;
    }

    const hasInAppHistory =
      window.history.state &&
      window.history.state.idx !== undefined &&
      window.history.state.idx > 0;

    if (hasInAppHistory) {
      navigate(-1); // Назад по истории приложения
    } else {
      navigate("/");
    }
  };

  return (
    <StyledGoBackButton onClick={handleGoBack}>
      <IconArrowLeftSvg />
      {text}
    </StyledGoBackButton>
  );
};
